import React from 'react';

const ButtonGap = () => {
    return <span className="inline-block grow">&nbsp;</span>
}

export default ButtonGap;